module.exports = __webpack_public_path__ + "static/media/pic2@3x.952efe70.png";